export const DATA =
{
    title:'Referanslar',
    category: [
        {
            id:0,
            type: 'Tümü',


        },
        {
            id:1,
            type: 'Endüstri',
            contentArray: [
                {image: '/image/references/yurtici/endustri/polisan.png', name: 'polisan'},
                {image: '/image/references/yurtici/endustri/poliport.png', name: 'poliport'},
                {image: '/image/references/yurtici/endustri/akkim.png', name: 'akkim'},
                {image: '/image/references/yurtici/endustri/dogus.png', name: 'dogus'},
                {image: '/image/references/yurtici/endustri/kordsa.png', name: 'kord-sa'},
                {image: '/image/references/yurtici/endustri/starwood.png', name: 'starwood'},
                {image: '/image/references/yurtici/endustri/kastamonu.png', name: 'kastamonu'},
                {image: '/image/references/yurtici/endustri/yildizentegre.png', name: 'yildizentegre'},
                {image: '/image/references/yurtici/endustri/dunapac.png', name: 'dunapacdentas'},
                {image: '/image/references/yurtici/endustri/beyaz-kagit.png', name: 'beyazkagit'},
                {image: '/image/references/yurtici/endustri/kara-holding.png', name: 'karaholding'},
                {image: '/image/references/yurtici/endustri/assan.png', name: 'assanaluminyum'},
                {image: '/image/references/yurtici/endustri/kaanlar.png', name: 'kaanlar'},
                {image: '/image/references/yurtici/endustri/aksa.png', name: 'aksa'},
                {image: '/image/references/yurtici/endustri/isdemir.png', name: 'isdemir'},
                {image: '/image/references/yurtici/endustri/kardemir.png', name: 'kardemir'},
                {image: '/image/references/yurtici/endustri/kivanc.png', name: 'kivanc'},
                {image: '/image/references/yurtici/endustri/korsan.png', name: 'köksan'},
                {image: '/image/references/yurtici/endustri/tosyalı.png', name: 'tosyali-toyo'},
                {image: '/image/references/yurtici/endustri/assanhanil.png', name: 'assanhanil'},
                {image: '/image/references/yurtici/endustri/tatmetal.png', name: 'tatmetal'},
                {image: '/image/references/yurtici/endustri/asil-celik.png', name: 'asilcelik'},
                {image: '/image/references/yurtici/endustri/tekno.png', name: 'tekno'},
                {image: '/image/references/yurtici/endustri/petlas.png', name: 'petlas'},
                {image: '/image/references/yurtici/endustri/ensar.png', name: 'ensar'},
                {image: '/image/references/yurtici/endustri/hayat.png', name: 'hayat'},
                {image: '/image/references/yurtici/endustri/alkim.png', name: 'alkim'},
                {image: '/image/references/yurtici/endustri/aynes.png', name: 'aynes'},
                {image: '/image/references/yurtici/endustri/eti-maden.png', name: 'etimadenisletmeleri'},
                {image: '/image/references/yurtici/endustri/enpay.png', name: 'enpay'},
                {image: '/image/references/yurtici/endustri/menderes.png', name: 'menderes'},
                {image: '/image/references/yurtici/endustri/toren.png', name: 'toren'},
                {image: '/image/references/yurtici/endustri/gural.png', name: 'guralseramik'},
                {image: '/image/references/yurtici/endustri/poly.png', name: 'polygurteks'},
                {image: '/image/references/yurtici/endustri/micha.png', name: 'micha'},
                {image: '/image/references/yurtici/endustri/erbakir.png', name: 'erbakir'},
                {image: '/image/references/yurtici/endustri/agt.png', name: 'AGT'},
                {image: '/image/references/yurtici/endustri/abb.png', name: 'ABB'},
                {image: '/image/references/yurtici/endustri/karaca.png', name: 'karaca'},
                {image: '/image/references/yurtici/endustri/ferrero.png', name: 'ferrero'},
                {image: '/image/references/yurtici/endustri/cargill.png', name: 'Cargill'},
                {image: '/image/references/yurtici/endustri/konfrut.png', name: 'KONFRUT'},
                {image: '/image/references/yurtici/endustri/dohler.png', name: 'dohler'},
                {image: '/image/references/yurtici/endustri/igsas.png', name: 'igsas'},
                {image: '/image/references/yurtici/endustri/anatolia.png', name: 'anatolia'},
                {image: '/image/references/yurtici/endustri/abalioglu.png', name: 'abalioglu'},
                {image: '/image/references/yurtici/endustri/asos.png', name: 'asos'},
                {image: '/image/references/yurtici/endustri/sek.png', name: 'sek'},
                {image: '/image/references/yurtici/endustri/bychem.png', name: 'bychem'},
                {image: '/image/references/yurtici/endustri/demmer.png', name: 'demmer'},
                {image: '/image/references/yurtici/endustri/ekon.png', name: 'ekon'},
                {image: '/image/references/yurtici/endustri/etibakir.png', name: 'etibakir'},
                {image: '/image/references/yurtici/endustri/hering.png', name: 'hering'},
                {image: '/image/references/yurtici/endustri/his.png', name: 'his'},
                {image: '/image/references/yurtici/endustri/karesi.png', name: 'karesi'},
                {image: '/image/references/yurtici/endustri/onur.png', name: 'onur'},
                {image: '/image/references/yurtici/endustri/perfektup.png', name: 'perfektup'},
                {image: '/image/references/yurtici/endustri/suru.png', name: 'suru'},
                {image: '/image/references/yurtici/endustri/truva.png', name: 'truva'},
       
             
        
  

                
                




            ]

        },
        {
            id:2,
            type: 'Enerji',
            contentArray: [
                {image: '/image/references/yurtici/enerji/zorlu.png', name: 'zorlu'},
                {image: '/image/references/yurtici/enerji/soyak.png', name: 'soyak'},
                {image: '/image/references/yurtici/enerji/izdemir.png', name: 'izdemirenerji'},
                {image: '/image/references/yurtici/enerji/kesir.png', name: 'kesir'},
                {image: '/image/references/yurtici/enerji/maren.png', name: 'maren'},
                {image: '/image/references/yurtici/enerji/teias.png', name: 'teias'},
                {image: '/image/references/yurtici/enerji/fabay.png', name: 'fabay'},
                {image: '/image/references/yurtici/enerji/akcaenerji.png', name: 'akcaenerji'},
                {image: '/image/references/yurtici/enerji/emirlerenerji.png', name: 'emirlerenerji'},
                {image: '/image/references/yurtici/enerji/turkerler.png', name: 'turkerler'},
                {image: '/image/references/yurtici/enerji/mbholding.png', name: 'mbholding'},
                {image: '/image/references/yurtici/enerji/ogulenerji.png', name: 'ogulenerji'},
                {image: '/image/references/yurtici/enerji/sonmezholding.png', name: 'sonmezholding'},
                {image: '/image/references/yurtici/enerji/iltekno.png', name: 'iltekno'},
                {image: '/image/references/yurtici/enerji/greeneco.png', name: 'greeneco'},
                {image: '/image/references/yurtici/enerji/yilsan.png', name: 'yilsan'},
                {image: '/image/references/yurtici/enerji/salbakos.png', name: 'salbakos'},
                {image: '/image/references/yurtici/enerji/mege.png', name: 'mege'},
                {image: '/image/references/yurtici/enerji/akkuyu.png', name: 'akkuyunukleer'},
                {image: '/image/references/yurtici/enerji/guney.png', name: 'guneybiyogaz'},
                {image: '/image/references/yurtici/enerji/sevval.png', name: 'sevval'},
                {image: '/image/references/yurtici/enerji/cwenerji.png', name: 'cwenerji'},
                {image: '/image/references/yurtici/enerji/hezenerji.png', name: 'hezenerji'},
                {image: '/image/references/yurtici/enerji/mazoon.png', name: 'mazoon'},
                {image: '/image/references/yurtici/enerji/sankoenerji.png', name: 'sankoenerji'},


            ]

        },
        {
            id:3,
            type: 'Oil & Gas',
            contentArray: [
                {image: '/image/references/yurtici/petrokimya/tupras.png', name: 'tupras'},
                {image: '/image/references/yurtici/petrokimya/turkiyepetrolleri.png', name: 'turkiyepetrolleri'},
                {image: '/image/references/yurtici/petrokimya/petkim.png', name: 'petkim'},
                {image: '/image/references/yurtici/petrokimya/starrafiner.png', name: 'starrafineri'},
                {image: '/image/references/yurtici/petrokimya/amecfoster.png', name: 'amecfosterwheeler'},
                {image: '/image/references/yurtici/petrokimya/blacksea.png', name: 'blacksea'},
                {image: '/image/references/yurtici/petrokimya/bp.png', name: 'bp'},
                {image: '/image/references/yurtici/petrokimya/qatargas.png', name: 'qatargas'},
                {image: '/image/references/yurtici/petrokimya/scp.png', name: 'scp'},
                {image: '/image/references/yurtici/petrokimya/siemens.png', name: 'siemens'},
                {image: '/image/references/yurtici/petrokimya/socar.png', name: 'socar'},
                {image: '/image/references/yurtici/petrokimya/tcd.png', name: 'tcd'},
                {image: '/image/references/yurtici/petrokimya/ung.png', name: 'ung'},

            ]

        },

    ]




}

